{
  "page_count": "od {n, plural, one{# stranice} other{# stranica}}"
}
